import { Filter, KeywordsConfig } from '../types/podlet';
import { isEmpty } from '../utils';
import { preProcessParameters } from './pre-processing';
import { TypeTransformationUtils } from './type-transformation';

export function filterKeywords(
    filter: Filter | undefined,
    config: Partial<KeywordsConfig>,
) {
    if (isEmpty(filter) || isEmpty(config)) {
        return {};
    }

    const parameters = preProcessParameters(config.preProcessingMap, filter);

    const keywords = TypeTransformationUtils.generatePlainMap(
        config.keywordsMap,
        parameters,
        config.ruleMap,
        true,
    );
    return keywords;
}

export function filterFeed(filter: Filter, config: Partial<KeywordsConfig>) {
    if (isEmpty(filter) || isEmpty(config)) {
        return {};
    }

    const parameters = preProcessParameters(config.preProcessingMap, filter);

    const feed = TypeTransformationUtils.generatePlainMap(
        config.feedMap,
        parameters,
        config.ruleMap,
        false,
    );
    return feed;
}

export function filterFeedString(
    filter: Filter,
    config: Partial<KeywordsConfig>,
) {
    if (isEmpty(filter) || isEmpty(config)) {
        return '';
    }

    const parameters = preProcessParameters(config.preProcessingMap, filter);

    const feedList = TypeTransformationUtils.generateList(
        config.feedMap,
        parameters,
        config.ruleMap,
    );
    const feedString = TypeTransformationUtils.listToDelimitedString(
        feedList,
        ';',
        false,
    );
    return feedString.toString();
}
